import { html, LitElement } from 'lit';
import { property } from 'lit/decorators.js';
import '@material/web/list/list-item.js';

/**
 * Supported behaviors for a list item.
 */
export type ListItemType = 'text' | 'button' | 'link';

export class IxListItem extends LitElement {
  /**
   * Disables the item and makes it non-selectable and non-interactive.
   */
  @property({ type: Boolean, reflect: true }) disabled = false;

  /**
   * Sets the behavior of the list item, defaults to "text". Change to "link" or
   * "button" for interactive items.
   */
  @property({ reflect: true }) type: ListItemType = 'text';

  /**
   * READONLY. Sets the `md-list-item` attribute on the element.
   */
  @property({ type: Boolean, attribute: 'md-list-item', reflect: true })
  isListItem = true;

  /**
   * Sets the underlying `HTMLAnchorElement`'s `href` resource attribute.
   */
  @property() href = '';

  /**
   * Sets the underlying `HTMLAnchorElement`'s `target` attribute when `href` is
   * set.
   */
  @property() target: '_blank' | '_parent' | '_self' | '_top' | '' = '';

  render() {
    return html`<md-list-item
      .disabled=${this.disabled}
      .type=${this.type}
      .href=${this.href}
      .target=${this.target}
      .isListItem=${this.isListItem}
      ><slot></slot
    ></md-list-item> `;
  }
}
